if (!process.env.REACT_APP_NO_CLEARBIT && !process.env.REACT_APP_NO_EXTERNAL) {
  const clearBit = document.createElement("script");
  clearBit.setAttribute("async", "async");
  clearBit.setAttribute("defer", "async");
  clearBit.setAttribute(
    "src",
    "https://tag.clearbitscripts.com/v1/pk_73c654d55e06e156528bc3a438c17205/tags.js"
  );

  document.body.appendChild(clearBit);
} else {
  console.info("Clearbit disabled");
}

// -----------------------------------------------------------------------------

export {};
